// Password
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':\"\\|,.<>\/?]).{8,}$/;

// Email — use isValidEmail() from @/utils/validate-email for full validation
export { isValidEmail } from "./validate-email";

// Phone number
export const phoneNumberRegex = /^\d{11,}$/;

// Full Phone number with country code
export const fullPhoneNumberRegex = /^\+\d{12,13}$/;

// Full name
export const fullNameRegex = /^[^\s]+\s+[^\s]+.*$/;
